'use strict';

DoohApps
    .directive('timePicker', ['$filter', function ($filter) {
        return {
            restrict: 'AE',
            scope: {
                isallday: '=',
                defaultTime: '=',
                onChange: '&'
            },
            link: function (scope, element) {

                var id = Math.random().toString(36).substr(2, 9);
                var txt = '<input id= "' + id + '" type="text" maxlength="5" style="width:60px;text-align:center;border:1px grey solid;cursor:grab" class="ui-corner-all"  />';

                var time = scope.defaultTime.split(':');
                var tmpDate = new Date();
                var date = new Date(tmpDate.getFullYear(), tmpDate.getMonth(), tmpDate.getDate(), time[0], time[1], 0);
                var showDate = $filter('date')(date, localStorage['TimeFormat']);//moment(date).format(localStorage['TimeFormat']);

                jQuery(txt).val(showDate).appendTo(element).datetimepicker({
                    datepicker: false,
                    format: localStorage['TimeFormat'],//'h:mm a',
                    formatTime: localStorage['TimeFormat'],//'h:mm a',
                    defaultTime: showDate,//scope.defaultTime,
                    step: 5,
                    onSelectTime: function (ct) {
                        scope.$apply(function () {
                            SetTime(ct);
                        });
                    },
                    onChangeDateTime: function (ct) {
                        scope.$apply(function () {
                            SetTime(ct);
                        });
                    }
                });

                function SetTime(ct) {
                    scope.defaultTime = $filter('date')(ct, localStorage['TimeFormat']);
                    $('#' + id).val(scope.defaultTime);
                }

                scope.$watch(function () { return scope.defaultTime }, function (newValue) {
                    scope.onChange();
                });

                scope.$watch(function () { return scope.isallday }, function (newValue) {
                    jQuery(element).first().show();
                    if (scope.isallday) {
                        jQuery(element).first().hide();
                    }

                });

            }
        }
    }]);